import React from 'react';
import PropTypes from 'prop-types';
import useSunburstChart from './useSunburstChart';

export default function SunburstChart({ movie, includeScenes, metric, dimNotOwed = true, onSelect, selectedId, autoSelectRoot = true, levelHighlight, interactive = true, size }) {
  const chartRef = useSunburstChart({ movie, includeScenes, metric, dimNotOwed, onSelect, animateAct1: interactive, selectedId, autoSelectRoot, levelHighlight, interactive, size });
  // width:100%, height auto — the wheel is sized to the column WIDTH by the hook, so the
  // div grows to the wheel's height and the LEFT COLUMN (overflow-y:auto) scrolls it; the
  // page itself never scrolls. Width drives the size, not the squeezed visible height.
  return <div ref={chartRef} style={{width: '100%'}}/>;
}
SunburstChart.propTypes = {
  movie: PropTypes.object.isRequired,
  includeScenes: PropTypes.bool.isRequired,
  metric:        PropTypes.string.isRequired,
  dimNotOwed:    PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedId: PropTypes.string,
  autoSelectRoot: PropTypes.bool,
  levelHighlight: PropTypes.array,   // per-instance highlight ids; omit to use the global channel
  interactive: PropTypes.bool,       // false = static teaching ring (no click/zoom/pulse)
  size: PropTypes.number,            // fixed px height/width (compact teaching ring); omit for width-driven
};